import React, {PureComponent} from "react"
import styled from "styled-components"

import {Body} from "@irati/ui/src/Typography"
import {FormattedMessage} from "@irati/utils/lang"
import theme from "@irati/ui/src/global/theme"
import Icon from "@irati/ui/src/Icon"

const Sent = styled.div`
  display: flex;
`

const Text = styled(Body)`
  color: ${theme.colors.perkbox.greenBlue};
  margin: 3px 5px;
`

interface Props {
  lastThreeDigits: string
}

class SentText extends PureComponent<Props> {
  render() {
    const {lastThreeDigits} = this.props
    return (
      <Sent>
        <Icon icon="tick" color={theme.colors.perkbox.greenBlue} />
        <Text small>
          <FormattedMessage id="medical.code.sentText" values={{lastThreeDigits}} />
        </Text>
      </Sent>
    )
  }
}

export default SentText
